<a (click)="close()" [class.upSlider-container]="showBox">
  <div class="upSlider" [class.show]="showBox">
    <div class="slider-box">
      <div class="slider-header">
        <a (click)="close()">
          <img src="assets/img/gray-down-arrow.svg" alt="">
        </a>
      </div>
      <div class="slider-box-body">
        <h2 class="purpleText">{{message}}</h2>
      </div>
    </div>
  </div>
</a>